<template>
  <el-card>
    <div ref="chartContainer" style="width: 100%; height: 600px;" />
  </el-card>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'PopUpStat2',
  props: {
    typ: {
      Type: String,
      default: 'page_count'
    },
    title: {
      Type: String,
      default: '弹框次数'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: ''
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(data, typeData) {
      this.initChart()
      this.option.title.text = this.title
      const date = []
      const chartData = {}
      const titleMap = {}
      for (const i in typeData) {
        const val = typeData[i]
        chartData[val.label] = []
        titleMap[val.label] = val.label
      }
      for (const i in data) {
        const val = data[i]
        date.push(val.date)
        for (const k in val.data.data) {
          const value = val.data.data[k]
          if (chartData[value.page_name]) {
            const _val = value[this.typ] || 0
            chartData[value.page_name].push(_val)
          }
        }
      }
      for (const i in chartData) {
        const val = chartData[i]
        const title = titleMap[i]
        this.option.legend.data.push(title)
        const temp = {
          name: title,
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }
        }
        this.option.series.push(temp)
      }
      this.option.xAxis.data = date
      this.chart.setOption(this.option, true)
    },
    getTitle(typeData) {
      for (const i in typeData) {
        const val = typeData[i]
        if (val.label === this.typ) {
          return val.label
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>

</style>
